import React, { useState } from 'react';
import { Text, View } from 'react-native';
import EditTextElement from './EditTextElement';
import Title from '../Text/Title';
import { Edit_text_elements, Text_elements_API } from '../../../utils/DictionaryManagementUtils';
import { LocStr } from '../../../utils/Utils';
import ExpandedText from '../Buttons/ExpandedText';
import { getDefaultGlobJSON } from '../../../defaultConfigurations/MainConfigurations';
import { getValue, setValue } from '../../../defaultConfigurations/UtilsConfigurations';

//= ========================================================================

const EditTextElements = ({
  globJSON, language, editTextList, apiTextList, onConfigChanged, editTextListDefault,
}) => {
  const defGlobJSON = getDefaultGlobJSON();
  const [isExpanded, setIsExpanded] = useState(false);
  const onTextChanged = (textId, newText) => {
    setValue(globJSON, textId, newText);
    onConfigChanged();
  };
  return (
    <View style={{ marginBottom: 30 }}>
      <ExpandedText
        isExpanded={isExpanded}
        onPress={() => setIsExpanded(!isExpanded)}
      >
        <Title marginBottom={0} isBold>{LocStr(Edit_text_elements, language)}</Title>
      </ExpandedText>
      {isExpanded
            && (
            <View>
              {editTextList.map((editTextId, index) => (
                <EditTextElement
                  editTextId={editTextId}
                  editTextValue={getValue(globJSON, editTextId)}
                  editTextDefValue={editTextListDefault ? getValue(defGlobJSON, editTextListDefault[index]) : getValue(defGlobJSON, editTextId)}
                  onTextChanged={(textId, newText) => {
                    onTextChanged(textId, newText);
                  }}
                />
              ))}
              {apiTextList
                    && (
                    <View>
                      <Text style={{ fontSize: 18, fontFamily: 'Quicksand-SemiBold', marginBottom: 15 }}>{Text_elements_API}</Text>
                      {apiTextList.map((editTextId) => (
                        <EditTextElement
                          editTextId={editTextId}
                          editTextValue={getValue(globJSON, editTextId)}
                          editTextDefValue={getValue(defGlobJSON, editTextId)}
                          onTextChanged={(textId, newText) => {
                            onTextChanged(textId, newText);
                          }}
                          notEditable
                        />
                      ))}
                    </View>
                    )}
            </View>
            )}
    </View>
  );
};
export default EditTextElements;
